<script>
  import {cn} from "$lib/utils.js";
  import GridRow from "./bits/calendar-grid-row.svelte";

  let {ref = $bindable(null), class: className, ...restProps} = $props();
</script>

<GridRow bind:ref class={cn("flex", className)} {...restProps}/>
